/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PublishsetRetrieveResponse } from '../types/PublishsetRetrieve';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type PublishsetsRetrieveRequest = {} | null | undefined;
export type PublishsetsRetrieveResponse = PublishsetRetrieveResponse;

export type PublishsetsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this publishset.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/publishsets/{id}/
 *
 * ```yaml
 * operationId: publishsets_retrieve
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetRetrieve'
 *     description: ''
 * ```
 */
export const publishsetsRetrieveOperation = ({ id, ...rest }: PublishsetsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/publishsets/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/publishsets/{id}/' };
  };

/**
 * GET /dmx-server/publishsets/{id}/
 *
 * ```yaml
 * operationId: publishsets_retrieve
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetRetrieve'
 *     description: ''
 * ```
 */
export const publishsetsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PublishsetsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PublishsetRetrieveResponse>> => {
  const operation = publishsetsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/publishsets/{id}/
 */
export const usePublishsetsRetrieveResource = (
  query: PublishsetsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<PublishsetsRetrieveResponse> => {
  return useResource<PublishsetsRetrieveResponse>({
    path: query === null ? null : publishsetsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
